import resultRetrievalSagas from './resultRetrievalSagas';
import resultCreationSagas from './resultCreationSagas';

export default [...resultRetrievalSagas, ...resultCreationSagas];



// WEBPACK FOOTER //
// ./src/sagas/resultSagas/index.js